import React from 'react';
import { Container, Row, Col,TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import './Messages.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faEnvelopeOpen , faEnvelope, faCalendar } from '@fortawesome/fontawesome-free-solid';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import Config from '../../Core/Config.js';
import { framework, ui } from 'saffroncodejs';
import classnames from 'classnames';
var PageManager = framework.PageManager;

class ReceivedMessages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [
        { companyName: 'شرکت سامان نگار ایرانیان', addressCo: 'تهران', faxCo: '84325', telCo: '84325', locationCo: '627.2238657537844 M' }
      ],
      bmMessages:[{}],
      activeTab: '1',
      isLoading: true,
      isLoading2: true,
    };
    this.toggle = this.toggle.bind(this);
    this.state.messages = [];
    this.state.bmMessages=[];
    Axios.get(Config.domain_pic + "/GetUserQuestions?UserId=" + UserManager.getUserToken()
    )
      .then((result) => {
        console.log("result.news: ", JSON.stringify(result.data));
        this.setState({ messages: result.data.QuestionReplies, isLoading: false });
        
      }
      )

     this.loadBNMessages();
  }
  loadBNMessages() {
    Axios.post(BimeManager.reactRedirectDomain,
        BimeManager.makeBody("/NovinInsuranceServices/Not/api/Not/Notification",

            { codeMelli: UserManager.MelliCode() }
        ),
        BimeManager.header())
        .then((result) => {
            console.log("result.data : ", result.data);
            this.setState({ bmMessages: result.data, isLoading2: false })
        })
        .catch((error) => { alert(error) })
}
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }
  render() {
    return (
      <div>

        <Container>
          <Row>
            <Col sm="12" className="alignRight title">
              <h4>پیام ها</h4>
            </Col>
          </Row>
          {/* Tab */}
          <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '1' })}
              onClick={() => { this.toggle('1'); }}
            >
              پیام ها 
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => { this.toggle('2'); }}
            >
             اطلاع رسانی
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            {(!this.state.isLoading) ? this.state.messages.map((messageItem) => (
                <Row className="received_messsages">
                  <Col sm="12" className="message_item" onClick={() => PageManager.changePage(Config.p_receivedsinglemessage, [messageItem.Id,this.state.activeTab])} >
                    <Row>
                      <Col sm="1">{(messageItem.IsReplyRead && messageItem.IsMessage)||(!messageItem.IsMessage && (messageItem.ReplyText==null || messageItem.IsReplyRead)) ?<FontAwesomeIcon icon={faEnvelopeOpen} className="fontinMessage" />:<FontAwesomeIcon icon={faEnvelope} className="fontinMessage fontinMessageUnread" />}</Col>
                      <Col sm="11"><h5>{messageItem.Subject}{messageItem.ReplyText!==null?'(پاسخ داده شده)':''}</h5>
                        <p>
                          {messageItem.Body}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )):<ui.Preloader />}
          </TabPane>
          <TabPane tabId="2">
            {(!this.state.isLoading2) ?this.state.bmMessages.map((messageItem1) => (
              
                  <Row className="received_messsages">

                    <Col sm="12" className="message_item" onClick={() => PageManager.changePage(Config.p_receivedsinglemessage, [messageItem1.Id,this.state.activeTab])} >
                      <Row>
                        <Col sm="1"><FontAwesomeIcon icon={faEnvelopeOpen} className="fontinMessage" /></Col>
                        <Col sm="11"><h5>{messageItem1.Content}</h5>
                        <p>
                          {messageItem1.RegDate}
                        </p>
                           {/*<p>
                          <FontAwesomeIcon icon={faCalendar} className="fontinMessage" /> {messageItem1.RegDate}
                            
                          </p>
                          <p>
                            {messageItem1.Content}
                          </p>
                          <a href={messageItem1.RelatedLink} target="_blank" >{messageItem1.RelatedLinkTitle}</a> */}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  
                )):<ui.Preloader />}
              
          </TabPane>
        </TabContent>
          {/* Tab */}
         
         

        </Container>

      </div>
    );
  }
}
export default ReceivedMessages;


// WEBPACK FOOTER //
// ./src/components/Messages/ReceivedMessages.js